import { Button } from '../../Components/Button/Button'
import './Login.scss'
import { useState } from 'react'
import { useLocalization } from '../../Hooks/useLocalization'
import { TextInput } from '../../Components/TextInput/TextInput'
import { isValidEmail } from '../../Utils/Validations'

export function Login() {
  const localization = useLocalization('login')
  const [email, setEmail] = useState('')

  const [loginEmailSend, setLoginEmailSend] = useState(false)

  const login = () => {
    fetch(
      `https://qrzszdu3vd.execute-api.eu-west-1.amazonaws.com/default/login`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email,
        }),
      }
    ).catch((err) => {
      console.warn(`fetch login failed: `, err)
    })

    setLoginEmailSend(true)
  }

  return (
    <div className="login">
      {loginEmailSend ? (
        <>
          {localization.text(
            'login-email-send',
            'Indien de email gelinkt is aan een account. Hebben we een login link verstuurd naar het opgegeven email address. klik op deze link om in te loggen.'
          )}
        </>
      ) : (
        <>
          <TextInput
            label={localization.text('login-email', 'Login email')}
            value={email}
            onChange={setEmail}
            isValid={!email || isValidEmail(email)}
          />
          {email && isValidEmail(email) ? (
            <Button
              importance={'primary'}
              text={localization.text('login-button', 'Inloggen')}
              onClick={login}
            />
          ) : null}
        </>
      )}
    </div>
  )
}
